import React from "react"
import { Button, Form, DatePicker } from "antd"
import PropTypes from "prop-types"

import { W2 } from "@components"

const LABEL_CONTINUE = "Continue"
const LABEL_DATE_RANGE = "Date Range"
const LABEL_RANGE_REQUIRED = "Select date range"


const OrganizationsDateRangeForm = ({ onSubmit }) => {
  const [ form ] = Form.useForm()

  const onFinish = ({ dateRange }) =>
    onSubmit(dateRange)

  const formProps = {
    style: { marginTop: W2 },
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
    onFinish,
    form,
  }

  const buttonProps = {
    type: "primary",
    htmlType: "submit",
    style: { marginLeft: 124 },
  }

  const rangePickerProps = {
    picker: "month",
    format: "MM/YYYY",
  }

  const dateRangeItemProps = {
    name: "dateRange",
    label: LABEL_DATE_RANGE,
    rules: [
      {
        required: true,
        message: LABEL_RANGE_REQUIRED,
      },
    ],
  }

  return (
    <Form {...formProps}>
      <Form.Item {...dateRangeItemProps}>
        <DatePicker.RangePicker {...rangePickerProps} />
      </Form.Item>

      <Form.Item>
        <Button {...buttonProps}>
          {LABEL_CONTINUE}
        </Button>
      </Form.Item>
    </Form>
  )
}

OrganizationsDateRangeForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
}

export default OrganizationsDateRangeForm
